// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UserApiKeyPagingResultModel from '../../model/user-api-key-paging-result-model';
import UserApiKeyPagingResultDTO from '../dto/user-api-key-paging-result-dto';
import dtoSchema from '../schemas/user-api-key-paging-result-schema';
import UserApiKeyModel from '../../model/user-api-key-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class UserApiKeyPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UserApiKeyPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => UserApiKeyModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: UserApiKeyModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<UserApiKeyPagingResultDTO>): UserApiKeyPagingResultModel;
  static toModel(dto: DeepPartial<UserApiKeyPagingResultDTO> | undefined | null): UserApiKeyPagingResultModel | undefined;
  static toModel(dto: DeepPartial<UserApiKeyPagingResultDTO> | undefined | null): UserApiKeyPagingResultModel | undefined {
    return dto ? new UserApiKeyPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UserApiKeyPagingResultModel> | UserApiKeyPagingResultModel): UserApiKeyPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as UserApiKeyPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UserApiKeyPagingResultModel, can not map to UserApiKeyPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
